import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';

import {
  NavbarTopWrapper,
  NavbarTopTitleWrapper,
  NavbarTopTitle,
  NavbarTopArrow,
  NavbarTopElements,
} from './styles.Navbar';

import { titles } from '../../data/titles';
import { appColors } from '../../config/colors';

type Props = {
  currentSection: string;
};

export const NavbarTop: React.FC<Props> = ({ currentSection }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentTitle, setCurrentTitle] = useState('');

  useEffect(() => {
    const title = titles.find((t) => t.id === currentSection);

    if (title && title.name) {
      setCurrentTitle(title.name);
    }
  }, [currentSection]);

  const navbarTopElements = (
    <NavbarTopElements hidden={!menuOpen}>
      {titles.map((title) => (
        <a
          key={title.id}
          href={`#${title.id}`}
          onClick={() => setMenuOpen(false)}
        >
          {title.name}
        </a>
      ))}
    </NavbarTopElements>
  );

  return (
    <NavbarTopWrapper>
      <NavbarTopTitleWrapper>
        <NavbarTopTitle>{currentTitle}</NavbarTopTitle>
        <NavbarTopArrow onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? (
            <ChevronUp color={appColors.navbarFont} size={24} />
          ) : (
            <ChevronDown color={appColors.navbarFont} size={24} />
          )}
        </NavbarTopArrow>
      </NavbarTopTitleWrapper>
      {navbarTopElements}
    </NavbarTopWrapper>
  );
};
